import { useCashierAuthStore } from '../../store/cashierAuthStore';
import type { AuthSubsidiary, AuthUser } from '../../lib/cashierAuthClient';
import { useLang } from '../../lib/language';
import { PickerCard, PickerLayout } from './PickerLayout';

export function SubsidiaryPickerScreen({
  user, subsidiaries, busy,
}: {
  user: AuthUser;
  subsidiaries: AuthSubsidiary[];
  busy: boolean;
}): JSX.Element {
  const { t } = useLang();
  const error = useCashierAuthStore((s) => s.error);
  const choose = useCashierAuthStore((s) => s.chooseSubsidiary);
  const logout = useCashierAuthStore((s) => s.logout);

  return (
    <PickerLayout
      title={t({ en: 'Choose a company', ar: 'اختر شركة' })}
      subtitle={t({ en: `Signed in as ${user.username}`, ar: `مُسجّل الدخول باسم ${user.username}` })}
      error={error}
      onLogout={() => logout()}
      busy={busy}
    >
      <ul style={{ listStyle: 'none', margin: 0, padding: 0 }}>
        {subsidiaries.map((s) => (
          <PickerCard
            key={s.id}
            title={s.name}
            subtitle={s.code ? t({ en: `Code: ${s.code}`, ar: `الرمز: ${s.code}` }) : null}
            onClick={() => void choose(s.id)}
            disabled={busy}
          />
        ))}
      </ul>
    </PickerLayout>
  );
}
